import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { HashLink as Link } from 'react-router-hash-link';
import { Helmet } from 'react-helmet';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HeroImage from './HeroImage';
import PolicyData from '../Common/data/policy-review/PolicyData';
import { PolicyReviewContact } from '../Common/Constant';
import FAQs from '../ProductLanding/FAQs';
import '../ProductLanding/Product.scss';

const useStyles = makeStyles(theme => ({
  hyperlinks: {
    backgroundColor: 'white',
    margin: '0px -40px',
    color: theme.palette.primary.main,
    boxShadow: '5px 3px 5px lightgrey'
  },
  activeLink: {
    borderBottom: `2px solid ${theme.palette.primary.main}`
  },
  primaryText:{
    'color': theme.palette.primary.main,
    'font-weight':600
  },
  productTab:{
    position: 'sticky',
    top:74,
    zIndex:9
  }
}));

const useButtonStyles = makeStyles(theme => ({
  button: {
    color: theme.palette.primary.main,
    fontWeight: 700
  }
}));
export default function PolicyReview(props) {

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  var data = PolicyData();
  const classes = useStyles();
  const buttonStyle = useButtonStyles().button;

  const [activeTab, setActiveTab] = useState(0);

  const offsetAnchor = index => {
    setActiveTab(index);
    const headerHeight = document.getElementById('advisor-nav').offsetHeight;
    const productHeaderHeight = document.getElementById('product-header').offsetHeight;
    window.setTimeout(function () {
      window.scrollTo(window.scrollX, window.scrollY - (productHeaderHeight+headerHeight));
    }, 5);
  };

  return (
    <Container fluid className="product-landing">
      <Helmet>
        <title>Covr Advisor - {data.name}</title>
      </Helmet>
      <div id="product-header" className={classes.productTab}>
        <HeroImage title={data.name} subtitle={data.subtitle} permission={props.permission} />
        <Row className={classes.hyperlinks}>
          {data.hyperlinks.map((h, i) => (
            <Link key={i} smooth to={h.link} className={`sub-nav-link-button ${activeTab === i ? classes.activeLink : null}`} onClick={() => offsetAnchor(i)}>
              <Button variant="text" className={buttonStyle}>
                {h.title}
              </Button>
            </Link>
          ))}
        </Row>
      </div>
      <Row className="mt-4">
        <Col md={8} className="pr-5">
          <AboutData data={data.about} />
          <WatchVideo data={data.video} />
          <WhoShouldConsider data={data.whoShouldConsider} />
          <PurchasingSteps data={data.PurchasingSteps} />
          <PolicyReviewInfo data={data.PolicyReviewInfo} />
          <FAQs showExpandIconAtLeft={true} className="product-row" data={data.faq} />
        </Col>
      </Row>
    </Container>
  );
}

function AboutData(props) {
  const { data } = props;
  const classes = useStyles();
  return (
    <Container className="pl-0">
      <Row id="about" className="mb-2">
        <div>
          <div className="mb-3 product-title">{data.title}</div>
          <div className="product-content">{data.content}</div>
          <br />
          <Container>
            <Row className="did-you-know product-content">
              <Col lg={11}>
                <div className="product-content">
                  <b>Did You Know?</b>
                  <br />
                  {data.didYouKnow}
                </div>
              </Col>
            </Row>
          </Container>
          <div className="mt-3 product-content">
            Policy Review Team
            <p className={`${classes.primaryText} mb-0`}>{PolicyReviewContact}</p>
          </div>
        </div>
      </Row>
    </Container>
  );
}

function WatchVideo(props) {
  const { data } = props;
  return (
    <React.Fragment>
      {data && (
        <Container className="pl-0 pt-3">
          <Row className="mb-4 pl-0">
            <div className="mb-3 product-title">Watch a Video</div>
            <div className="embed-responsive embed-responsive-16by9">
              <iframe src={data.link} className="embed-responsive-item" title={props.title} />
            </div>
            <div className="video-description-header mt-2">{data.description}</div>
            <div className="product-content">{data.content}</div>
          </Row>
        </Container>
      )}
    </React.Fragment>
  );
}

function WhoShouldConsider(props) {
  const { data } = props;

  return (
    <Container className="pl-0">
      <Row id="whoShouldConsider" className="mb-4">
        <div>
          <div className="mb-3 product-title">{data.title}</div>
          <ul>
            {data.paragraphs.map((v, i) => (
              <li className="product-content" key={i}>
                {v}
              </li>
            ))}
          </ul>
        </div>
      </Row>
    </Container>
  );
}

function PolicyReviewInfo(props) {
    const { data } = props;

    return (
      <React.Fragment>
        {data && (
          <Container id="policyReviewInfo" className="pl-0">
            <Row className="mb-4">
              <div>
                <div className="mb-3 product-title">{data.title}</div>
                <div className="product-content">{data.content}</div>
              </div>
            </Row>
          </Container>
        )}
      </React.Fragment>
    );
}

function PurchasingSteps(props) {
  const { data } = props;

  return (
    <React.Fragment>
      {data && (
        <Container className="pl-0">
          <Row id="PurchasingSteps" className="mb-4">
            <div>
              <div className="mb-4 product-title">{data.title}</div>
              <div className="product-content">{data.headline}</div>
              <ol>
                {data.steps.map((v, i) => (
                  <li className="product-content" key={i}>
                    {v}
                  </li>
                ))}
              </ol>
              <div className="product-content">{data.secondHeadline}</div>
              <ul>
                {data.paragraphs.map((v, i) => (
                  <li className="product-content" key={i}>
                    {v}
                  </li>
                ))}
              </ul>
            </div>
          </Row>
        </Container>
      )}
    </React.Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/components/PolicyReview/PolicyReview.js